import { useState, type MouseEvent } from "react";
import { Award, BadgeCheck, ClipboardCheck, Wrench, type LucideIcon } from "lucide-react";
import { auctionGradeById, type AuctionCondition } from "@shared/auction-condition";
import { DialogTrigger } from "@/components/ui/dialog";
import { AuctionConditionDialog } from "./auction-condition-dialog";

const ICONS: Record<AuctionCondition["icon"], LucideIcon> = {
  award: Award,
  "badge-check": BadgeCheck,
  "clipboard-check": ClipboardCheck,
  wrench: Wrench,
};

export function AuctionConditionChip({
  gradeId,
}: {
  gradeId: string | null | undefined;
}) {
  const grade = auctionGradeById(gradeId);
  const [open, setOpen] = useState(false);
  if (!grade) return null;

  const Icon = ICONS[grade.icon];

  const onClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    event.stopPropagation();
    setOpen(true);
  };

  return (
    <AuctionConditionDialog gradeId={grade.id} open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button
          type="button"
          onClick={onClick}
          className="inline-flex max-w-full items-center gap-1.5 rounded-full border border-neutral-200 bg-white/95 px-2.5 py-1 text-start text-[11px] font-semibold leading-tight text-neutral-800 shadow-sm backdrop-blur-sm hover:bg-white"
        >
          <Icon className="size-3.5 shrink-0" aria-hidden />
          {grade.line}
        </button>
      </DialogTrigger>
    </AuctionConditionDialog>
  );
}
